<div class="grid">
  <p-messages severity="info">
    <ng-template pTemplate>
      <i class="pi pi-info-circle" style="font-size: 1rem; margin-right: 8px"></i>
      <div class="ml-2:md text-message">
        <p>
          Asegúrate de tener acceso como administrador. Si no eres tú quién administra el sitio,
          contáctate con la persona que tenga acceso.
        </p>
      </div>
    </ng-template>
  </p-messages>
  <form [formGroup]="discordBot" (ngSubmit)="onSubmitServerId()" class="bodyForm">
    <div class="mt-2">
      <p>
        1. Ingresa el <b>ID de tu servidor</b> de discord. Lo encuentras si vas a
        <b>Configuraciones / Avanzado / Activar modo desarrollador.</b> Luego de activar este modo,
        haz clic derecho al icono del servidor y luego a “copiar ID del servidor”.
      </p>
      <div class="input-group">
        <input
          pInputText
          formControlName="serverName"
          placeholder="Nombre servidor"
          style="width: 240px"
        />
        <input
          pInputText
          formControlName="serverId"
          placeholder="ID servidor"
          [class.ng-invalid]="
            discordBot.get('serverId')?.invalid && discordBot.get('serverId')?.touched
          "
        />
        <span class="editServerId">
          <button (click)="onSubmitServerId()" class="col-12 padding save">Guardar</button>
        </span>
      </div>
    </div>
    <div class="mt-5">
      <p>
        2. Ingresa el <b>nombre de los canales</b> donde quieres que esté disponible Globot. Si no
        ingresas ninguno quedará por defecto en todos los canales.
      </p>
      <div class="input-group">
        <p-chips
          class="channelsChip"
          [max]="10"
          formControlName="channelNames"
          separator=","
          placeholder="Ingresa un canal y presiona “Enter”"
        ></p-chips>
        <button (click)="onSubmitChannels()" class="col-12 save">Guardar</button>
      </div>
    </div>
    <div class="mt-3">
      <p>
        3. <b>Descarga</b> e <b>instala Globot</b> desde la siguiente dirección:

        <button (click)="linkBot()" class="btn-link">
          Discord.com/globot <i class="pi pi-link"></i>
        </button>
      </p>

      <p>
        4. ¡Listo! Activa tu asistente en este canal y para llamarlo, solo menciona
        <b>"@globot"</b>como lo harías con cualquier otro usuario.
      </p>
      <div class="flex-container">
        <p-inputSwitch
          [disabled]="!serverId"
          formControlName="checked"
          (change)="switchChanged($event)"
        ></p-inputSwitch>
        <span style="margin-left: 5px">Activar chatbot en este canal</span>
      </div>
    </div>
  </form>
</div>
